// Reusable starting points (MemoNest feature; the reference app has no templates).

export interface TemplateLine {
  text: string;
  kind: 'text' | 'check';
  heading?: boolean;
}

export interface NoteTemplate {
  id: string;
  name: string;
  kind: 'checklist' | 'planner' | 'note';
  designId: string;
  description: string;
  lines: TemplateLine[];
  /** Suggested schedule for routine templates. */
  suggest?: { time: string; weekdays: number[] };
}

const c = (text: string): TemplateLine => ({ text, kind: 'check' });
const t = (text: string, heading = false): TemplateLine => ({ text, kind: 'text', heading });

export const TEMPLATES: NoteTemplate[] = [
  {
    id: 'morning',
    name: 'Morning routine',
    kind: 'checklist',
    designId: 'mn-summer-sun',
    description: 'Start the day the same way every day.',
    lines: [c('Water'), c('Stretch 5 min'), c('Plan top 3'), c('Breakfast')],
    suggest: { time: '07:00', weekdays: [1, 2, 3, 4, 5] },
  },
  {
    id: 'evening',
    name: 'Evening routine',
    kind: 'checklist',
    designId: 'mn-midnight-ink',
    description: 'Wind down and prepare for tomorrow.',
    lines: [c('Tidy desk'), c('Pack bag'), c('Screens off'), c('Read 10 pages')],
    suggest: { time: '21:00', weekdays: [0, 1, 2, 3, 4, 5, 6] },
  },
  {
    id: 'shopping',
    name: 'Shopping list',
    kind: 'checklist',
    designId: 'ref-01',
    description: 'Groceries and errands.',
    lines: [c('Milk'), c('Eggs'), c('Bread'), c('Fruit')],
    suggest: { time: '17:30', weekdays: [6] },
  },
  {
    id: 'work',
    name: 'Work planner',
    kind: 'planner',
    designId: 'mn-today',
    description: 'Today’s priorities and meetings.',
    lines: [t('Top priority', true), c(''), t('Meetings', true), c(''), t('Follow up', true), c('')],
    suggest: { time: '09:00', weekdays: [1, 2, 3, 4, 5] },
  },
  {
    id: 'study',
    name: 'Study planner',
    kind: 'planner',
    designId: 'mn-notebook',
    description: 'One session, one goal.',
    lines: [t('Goal', true), t(''), c('Review notes 25 min'), c('Practice questions'), c('Summarise in 3 lines')],
    suggest: { time: '18:00', weekdays: [1, 2, 3, 4] },
  },
  {
    id: 'habits',
    name: 'Habit tracker',
    kind: 'checklist',
    designId: 'mn-habit-tracker',
    description: 'Daily habits to tick off.',
    lines: [c('Walk 8k steps'), c('Drink 2 L water'), c('No phone in bed'), c('Journal')],
    suggest: { time: '20:00', weekdays: [0, 1, 2, 3, 4, 5, 6] },
  },
  {
    id: 'focus',
    name: 'Daily focus',
    kind: 'note',
    designId: 'mn-focus-red',
    description: 'One thing that matters today.',
    lines: [t('Today I will', true), t('')],
    suggest: { time: '08:00', weekdays: [1, 2, 3, 4, 5] },
  },
  {
    id: 'packing',
    name: 'Packing list',
    kind: 'checklist',
    designId: 'mn-beach-day',
    description: 'Don’t forget the charger.',
    lines: [c('Passport / ID'), c('Charger'), c('Toothbrush'), c('Medicine')],
  },
  {
    id: 'weekly',
    name: 'Weekly review',
    kind: 'planner',
    designId: 'mn-daily-plan',
    description: 'Look back, plan forward.',
    lines: [t('Wins', true), t(''), t('Next week', true), c(''), c('')],
    suggest: { time: '18:00', weekdays: [0] },
  },
];
